/* 
  плагин перехватывающий ошибки 
  (чтобы избежать 404 страницы на необработанных ошибках)
*/
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (err) => {
    console.error('Error handler capture: ', err)
  })
})
